import React from 'react';
import Footer from '../component/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is included

const Urooncology = () => {
  return (
    <>
      <div className="container my-5">
        <h1 className="text-center mb-4">Uro Oncology Care</h1>
        
        <h2 className="mt-4">Common Urological Cancers Treated</h2>
        <div className="mb-3">
          <h3>Kidney Cancer</h3>
          <p className="text-justify">
            Kidney cancer, or renal cell carcinoma, often develops in the lining of small tubes in the kidney. 
            Early detection is critical for successful treatment. We offer minimally invasive surgery, 
            such as robot-assisted partial nephrectomy or laparoscopic/robotic nephrectomy, which aim to 
            remove the cancer while preserving as much of the healthy kidney tissue as possible.
          </p>
        </div>
        <div className="mb-3">
          <h3>Bladder Cancer</h3>
          <p className="text-justify">
            Bladder cancer is one of the most common urological cancers and typically begins in the cells 
            lining the inside of the bladder. Early symptoms may include blood in the urine and frequent 
            urination. Treatment may involve transurethral resection of bladder tumor (TURBT), intravesical 
            therapy, or more advanced surgical options such as radical cystectomy.
          </p>
        </div>
        <div className="mb-3">
          <h3>Testicular Cancer</h3>
          <p className="text-justify">
            Testicular cancer primarily affects younger men and typically presents as a lump or swelling in 
            the testicle. Early diagnosis and treatment are critical. Our team provides orchiectomy 
            (surgical removal of the affected testicle) and, when needed, retroperitoneal lymph node dissection 
            (RPLND) or chemotherapy.
          </p>
        </div>
        
        <h2 className="mt-4">Advanced Diagnostic Tools</h2>
        <p className="text-justify">
          Early detection and accurate diagnosis are key to successful treatment. At Max Super Speciality Hospital, 
          we employ advanced diagnostic tools, including:
        </p>
        <ul>
          <li>
            <strong>MRI and CT Scans:</strong> Used for imaging tumors and determining the cancer stage.
          </li>
          <li>
            <strong>Biopsy:</strong> A tissue sample is taken for microscopic examination to confirm the 
            presence of cancer.
          </li>
          <li>
            <strong>Cystoscopy:</strong> A procedure to visualize the bladder and urethra to detect bladder cancer.
          </li>
        </ul>

        <h2 className="mt-4">Minimally Invasive and Robotic Surgery</h2>
        <p className="text-justify">
          Dr. Manish Khattar is highly skilled in using minimally invasive techniques for the treatment of 
          urological cancers. Procedures such as robot-assisted surgeries and laparoscopic/robotic surgeries 
          result in smaller incisions, less post-operative pain, shorter hospital stays, and quicker recovery times.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default Urooncology;
